export default function PreLoader() {
  return (
    <div id="loading">
      <div className="load-circle">
        <span className="one" />
      </div>
    </div>
  );
}
